// import { heapEvent } from '@equipmentshare/heaper'
import DeleteItem from 'views/item/components/DeleteItem'

export default function getDeleteItemModal( item: any, onSuccess?: () => void ) {
	return {
		component: DeleteItem,
		componentProps: { item },
		label: 'Delete Item',
		width: 372,
		onSuccess,
		onXClick: () => null, //console.log( 'TODO Heaper: Inventory - Delete Item Modal - Click - X button', {} ),
	}
}
